"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SegmentedButton", {
    enumerable: true,
    get: function() {
        return SegmentedButton;
    }
});
var _react = require("@chakra-ui/react");
var _components = require("../..");
var _hooks = require("../../../hooks");
var _react1 = _interop_require_wildcard(require("react"));
var _reactutils = require("@chakra-ui/react-utils");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _createContext = _sliced_to_array((0, _reactutils.createContext)({
    name: "SegmentedButtonContext"
}), 2), SegmentedButtonProvider = _createContext[0], useSegmentedButtonContext = _createContext[1];
var SegmentedButton = function(_param) {
    var children = _param.children, onChange = _param.onChange, _param_variant = _param.variant, variant = _param_variant === void 0 ? "primary" : _param_variant, _param_size = _param.size, size = _param_size === void 0 ? "l" : _param_size, _param_defaultValue = _param.defaultValue, defaultValue = _param_defaultValue === void 0 ? "" : _param_defaultValue, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, rest = _object_without_properties(_param, [
        "children",
        "onChange",
        "variant",
        "size",
        "defaultValue",
        "isDisabled"
    ]);
    var _useState = _sliced_to_array((0, _react1.useState)(defaultValue), 2), selectedValue = _useState[0], setSelectedValue = _useState[1];
    var responsiveSize = (0, _hooks.useResponsiveValue)(size);
    var handleChange = function(value) {
        setSelectedValue(value);
        onChange(value);
    };
    var getButtonStyles = function(isActive) {
        return (0, _react.useMultiStyleConfig)("SegmentedButton", {
            variant: variant,
            size: responsiveSize,
            isActive: isActive
        });
    };
    return _react1.default.createElement(SegmentedButtonProvider, {
        value: {
            getButtonStyles: getButtonStyles
        }
    }, _react1.default.createElement(_components.Flex, _object_spread(_object_spread_props(_object_spread({}, getButtonStyles().container), {
        role: "group"
    }), rest), children.map(function(child) {
        return (0, _react1.cloneElement)(child, {
            key: child.props.value,
            onClick: function() {
                return handleChange(child.props.value);
            },
            isActive: selectedValue === child.props.value,
            size: responsiveSize,
            isDisabled: isDisabled,
            "aria-current": selectedValue === child.props.value
        });
    })));
};
var Button = (0, _react.forwardRef)(function(_param, ref) {
    var children = _param.children, leadingIcon = _param.leadingIcon, trailingIcon = _param.trailingIcon, size = _param.size, isActive = _param.isActive, rest = _object_without_properties(_param, [
        "children",
        "leadingIcon",
        "trailingIcon",
        "size",
        "isActive"
    ]);
    var getButtonStyles = useSegmentedButtonContext().getButtonStyles;
    var leadingIconSized = getIcon(leadingIcon, size);
    var trailingIconSized = getIcon(trailingIcon, size);
    return _react1.default.createElement(_react.Button, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, getButtonStyles(isActive).button), {
        size: size
    }), rest), {
        ref: ref
    }), leadingIconSized, children, trailingIconSized);
});
SegmentedButton.Button = Button;
var IconButton = (0, _react.forwardRef)(function(_param, ref) {
    var icon = _param.icon, size = _param.size, isActive = _param.isActive, rest = _object_without_properties(_param, [
        "icon",
        "size",
        "isActive"
    ]);
    var getButtonStyles = useSegmentedButtonContext().getButtonStyles;
    var buttonStyles = getButtonStyles(isActive);
    var iconSized = getIcon(icon, size);
    return _react1.default.createElement(_react.Button, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, buttonStyles.button, buttonStyles.icon), {
        size: size
    }), rest), {
        ref: ref
    }), iconSized);
});
SegmentedButton.Icon = IconButton;
var getIcon = function(icon, size) {
    if (!(0, _react1.isValidElement)(icon)) {
        return null;
    }
    return (0, _react1.cloneElement)(icon, {
        size: size
    });
};
